// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteEstateWaterfallHypotheticalTransfersMutationVariables = Types.Exact<{
  estateWaterfallHypotheticalTransferIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type DeleteEstateWaterfallHypotheticalTransfersMutation = { __typename?: 'Mutation', deleteEstateWaterfallHypotheticalTransfers: number };

export const Operations = {
  Mutation: {
    DeleteEstateWaterfallHypotheticalTransfers: 'DeleteEstateWaterfallHypotheticalTransfers' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DeleteEstateWaterfallHypotheticalTransfersDocument = gql`
    mutation DeleteEstateWaterfallHypotheticalTransfers($estateWaterfallHypotheticalTransferIds: [ID!]!) {
  deleteEstateWaterfallHypotheticalTransfers(
    ids: $estateWaterfallHypotheticalTransferIds
  )
}
    `;
export type DeleteEstateWaterfallHypotheticalTransfersMutationFn = Apollo.MutationFunction<DeleteEstateWaterfallHypotheticalTransfersMutation, DeleteEstateWaterfallHypotheticalTransfersMutationVariables>;

/**
 * __useDeleteEstateWaterfallHypotheticalTransfersMutation__
 *
 * To run a mutation, you first call `useDeleteEstateWaterfallHypotheticalTransfersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstateWaterfallHypotheticalTransfersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstateWaterfallHypotheticalTransfersMutation, { data, loading, error }] = useDeleteEstateWaterfallHypotheticalTransfersMutation({
 *   variables: {
 *      estateWaterfallHypotheticalTransferIds: // value for 'estateWaterfallHypotheticalTransferIds'
 *   },
 * });
 */
export function useDeleteEstateWaterfallHypotheticalTransfersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEstateWaterfallHypotheticalTransfersMutation, DeleteEstateWaterfallHypotheticalTransfersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEstateWaterfallHypotheticalTransfersMutation, DeleteEstateWaterfallHypotheticalTransfersMutationVariables>(DeleteEstateWaterfallHypotheticalTransfersDocument, options);
      }
export type DeleteEstateWaterfallHypotheticalTransfersMutationHookResult = ReturnType<typeof useDeleteEstateWaterfallHypotheticalTransfersMutation>;
export type DeleteEstateWaterfallHypotheticalTransfersMutationResult = Apollo.MutationResult<DeleteEstateWaterfallHypotheticalTransfersMutation>;
export type DeleteEstateWaterfallHypotheticalTransfersMutationOptions = Apollo.BaseMutationOptions<DeleteEstateWaterfallHypotheticalTransfersMutation, DeleteEstateWaterfallHypotheticalTransfersMutationVariables>;